var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.container,
    on: {
      "click": _vm.onRedirect
    }
  }, [_c('div', {
    class: _vm.$style.icon
  }, [_c('svg', {
    attrs: {
      "width": "100%",
      "height": "100%",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('polygon', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "points": "6.414 13 12.707 19.293 11.293 20.707 2.586 12 11.293 3.293 12.707 4.707 6.414 11 21 11 21 13"
    }
  })])]), _c('div', {
    class: _vm.$style.title
  }, [_vm._v(_vm._s(_vm.title))]), _c('div', {
    class: _vm.$style.right
  }, [_vm._t("default")], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }